import { useContext } from 'react';
import { PropertyContext } from './PropertyContext';
export const usePropertyContext = () => {
  const context = useContext(PropertyContext);
  if (context === undefined) {
    throw new Error('usePropertyContext must be used within PropertyContextProvider');
  }
  return context;
};